export const MenuItemType = {
  Text: 'text',
  StaticUrl: 'static-url',
  Column: 'column',
} as const
